var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-58 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m229.457031 76.921875c-8.285156 0-15-6.714844-15-15v-12.9375c0-10.464844-7.308593-18.984375-16.296875-18.984375-8.984375 0-16.296875 8.519531-16.296875 18.984375v12.9375c0 8.285156-6.714843 15-15 15-8.28125 0-15-6.714844-15-15v-12.9375c0-27.007813 20.769531-48.984375 46.296875-48.984375s46.296875 21.976562 46.296875 48.984375v12.9375c0 8.285156-6.714843 15-15 15zm0 0",
    fill: "#ffad36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m214.457031 48.984375v12.9375c0 8.285156 6.714844 15 15 15 8.285157 0 15-6.714844 15-15v-12.9375c0-27.007813-20.769531-48.984375-46.296875-48.984375v30c8.988282 0 16.296875 8.519531 16.296875 18.984375zm0 0",
    fill: "#ffa100"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m252.847656 427.3125h-109.371094c-8.285156 0-15 6.714844-15 15 0 38.425781 31.257813 69.6875 69.683594 69.6875 38.425782 0 69.6875-31.261719 69.6875-69.6875 0-8.285156-6.714844-15-15-15zm0 0",
    fill: "#ffdf45"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m198.160156 512c38.425782 0 69.6875-31.261719 69.6875-69.6875 0-8.285156-6.714844-15-15-15h-54.6875zm0 0",
    fill: "#ffce00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m201.09375 55.929688h-5.867188c-86.1875 0-156.308593 70.121093-156.308593 156.308593v171.800781c0 8.285157 6.714843 15 15 15h288.484375c8.285156 0 15-6.714843 15-15v-171.800781c0-86.1875-70.117188-156.308593-156.308594-156.308593zm0 0",
    fill: "#ffdf45"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m201.09375 55.929688h-2.933594v343.109374h144.242188c8.285156 0 15-6.71875 15-15v-171.800781c0-86.1875-70.117188-156.308593-156.308594-156.308593zm0 0",
    fill: "#ffce00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m350.566406 369.039062h-304.8125c-25.226562 0-45.753906 20.523438-45.753906 45.753907v23.917969c0 10.257812 8.347656 18.601562 18.605469 18.601562h359.109375c10.261718 0 18.605468-8.34375 18.605468-18.601562v-23.917969c0-25.230469-20.523437-45.753907-45.753906-45.753907zm0 0",
    fill: "#ffad36"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m350.566406 369.039062h-152.40625v88.273438h179.558594c10.257812 0 18.601562-8.34375 18.601562-18.601562v-23.917969c0-25.230469-20.523437-45.753907-45.753906-45.753907zm0 0",
    fill: "#ffa100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.103e352c285dd0abc7d897a701b2f070.svg";
export { ForwardRef as ReactComponent };